import {
  FilterSelect,
  type FilterSelectOption,
  type FilterSelectProps,
} from "./filter-select";

export type LanguageSelectOption = FilterSelectOption;
export type LanguageSelectProps = FilterSelectProps;

export function LanguageSelect(props: LanguageSelectProps) {
  return <FilterSelect {...props} />;
}
